<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12 md8 offset-md2 xl6 offset-xl3 text-center>
                <v-sheet color="transparent" height="150">

                    <template v-if="loading">
                        <v-progress-circular class="mt-4" indeterminate width="1" color="primary" size="80" >
                            <v-icon color="primary">fa-hourglass-end</v-icon>
                        </v-progress-circular>
                    </template>

                    <div v-else :class="['drop-zone', dragging ? 'drop-zone-over' : '']" @dragenter.prevent="dragging = true" @dragleave.prevent="dragging = false">
                        <div class="drop-zone-info" @drag.prevent="onChange">
                            <span class="title">Click o arrastre su archivo aquí para cargarlo</span>
                            <div class="drop-zone-upload-limit-info mt-3">
                                <div>Tipos soportados: <b>{{allowedTypes.join(', ')}}</b>.</div>
                                <div>Tamaño máximo: <b>{{maxFileSize}}M</b>.</div>
                            </div>
                        </div>
                        <input type="file" @change="onChange" :accept="`${allowedMimeTypes.join(',')}`">
                    </div>


                </v-sheet>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    export default{
        props:{
            loading:{
                type: Boolean,
                default: false
            },
            maxFileSize:{
                type: Number,
                default: 10 //mb
            },
            allowedTypes:{
                type: Array,
                default: () => ['pdf', 'doc', 'jpeg', 'jpg', 'png']
            }
        },
        data(){
            return {
                file: '',
                dragging: false
            }
        },
        methods: {
            onChange(e) {
                var files = e.target.files || e.dataTransfer.files;

                if (!files.length) {
                    this.dragging = false;
                    return;
                }

                this.createFile(files[0]);
            },
            createFile(file) {

                var vm = this

                const fileTypes = vm.allowedTypes.map(type => `\\w\\/${type}`)
                const rule = `(${fileTypes.join('|')})`
                const regex = new RegExp(rule)

                if (!regex.test(file.type)){
                    vm.$emit('error:unsupported')
                    vm.dragging = false;
                    return;
                }

                if (file.size > (vm.maxFileSize * 1000000)) {
                    vm.$emit('error:max-size')
                    vm.dragging = false;
                    return;
                }

                this.$emit('select', file);
                this.dragging = false;

            },
            removeFile() {
                this.file = '';
            }
        },
        computed: {
            extension() {
                return (this.file) ? this.file.name.split('.').pop() : '';
            },
            allowedMimeTypes(){
                var vm = this
                return vm.allowedTypes.map(type => vm.mimeTypes[type])
            },
            mimeTypes(){
                return {
                    'png': 'image/png',
                    'jpg': 'image/jpg',
                    'jpeg': 'image/jpeg',
                    'gif': 'image/gif',
                    'pdf': 'application/pdf',
                    'mp4': 'video/mp4',
                    'mp3': 'audio/mp3',
                    'wav': 'audio/wav',
                    'ogg': 'audio/ogg',
                }
            }
        },
        watch:{
            file(val){
                if (!val.length) {
                    this.dragging = false;
                    return;
                }
                this.$emit('select', val[0]);
            }
        }
    }
</script>

<style scoped>
    .drop-zone {
        width: 100%;
        height: 100%;
        position: relative;
        border: 2px dashed #eee;
        border-radius: 10px;
    }

    .drop-zone:hover {
        border: 2px solid #9b9ba5;
    }

    .drop-zone:hover .drop-zone-title {
        color: #1975A0;
    }

    .drop-zone-info {
        color: #767676;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    ..drop-zone-title {
        color: #787878;
    }

    .drop-zone input {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .drop-zone-upload-limit-info {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .drop-zone-over {
        background: #c5cbcc;
        opacity: 0.8;
    }

    .drop-zone-uploaded {
        width: 80%;
        height: 200px;
        position: relative;
        border: 2px dashed #eee;
    }

    .drop-zone-uploaded-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #A8A8A8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .removeFile {
        width: 200px;
    }
</style>
